module.exports = __webpack_public_path__ + "img/SALA.69bea89d.jpg";